var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveContent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_323_8009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.1665C12.5 2.78579 11.3807 1.6665 10 1.6665C8.61929 1.6665 7.5 2.78579 7.5 4.1665V9.1665C7.5 10.5472 8.61929 11.6665 10 11.6665C11.3807 11.6665 12.5 10.5472 12.5 9.1665V4.1665Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 2.49984V4.1665M0.833332 1.6665V4.99984M15.8333 2.49984V4.1665M19.1667 1.6665V4.99984M4.16667 8.33317V9.1665C4.16667 10.7136 4.78125 12.1973 5.87521 13.2913C6.96917 14.3853 8.4529 14.9998 10 14.9998M10 14.9998C11.5471 14.9998 13.0308 14.3853 14.1248 13.2913C15.2188 12.1973 15.8333 10.7136 15.8333 9.1665V8.33317M10 14.9998V18.3332M10 18.3332H7.5M10 18.3332H12.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_323_8009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveContent);
export default __webpack_public_path__ + "static/media/activeContent.8ce16b395c57b8d4eeef6cac3fb2316e.svg";
export { ForwardRef as ReactComponent };